import { render, staticRenderFns } from "./BdrClients.vue?vue&type=template&id=43881909&scoped=true"
import script from "./BdrClients.vue?vue&type=script&lang=js"
export * from "./BdrClients.vue?vue&type=script&lang=js"
import style0 from "./BdrClients.vue?vue&type=style&index=0&id=43881909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43881909",
  null
  
)

export default component.exports